import script from "./dashbOphtalmo.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashbOphtalmo.vue?vue&type=script&setup=true&lang=ts"

import "./dashbOphtalmo.vue?vue&type=style&index=0&id=75ff7cb3&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75ff7cb3"]])

export default __exports__